import React from 'react';
import { motion } from 'framer-motion';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function DoctorsPage() {
  const doctors = [{
    name: 'Dr. Simbarashe Parirenyatwa, DDS',
    role: 'Lead Clinical Practitioner',
    specialty: 'Advanced Implants & Restorative Sedation Care. With over 15 years of experience in complex oral rehabilitation.',
    image: 'https://cdn.magicpatterns.com/uploads/wh5CZPBrkKFVWRYDjGnL2d/pexels-semih-demirbas-475034547-16098318.jpg'
  }, {
    name: 'Dr. Simons, DDS',
    role: 'Orthodontic & Cosmetic Specialist',
    specialty: 'Platinum Invisalign Provider & Aesthetic Veneers. Focused on creating perfectly balanced, natural smiles.',
    image: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?auto=format&fit=crop&q=80&w=400'
  }];
  return <div className="min-h-screen bg-#[F8FAFC] selection:bg-teal-100 selection:text-teal-900" data-id="element-609">
      <Header data-id="element-610" />
      <main className="pt-32 pb-24" data-id="element-611">
        <div className="max-w-7xl mx-auto px-4" data-id="element-612">
          <div className="text-center mt-8 mb-16 space-y-4" data-id="element-613">
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} className="inline-flex items-center gap-2 bg-[#54c595] text-white px-4 py-1.5 rounded-full shadow-sm" data-id="element-614">
              <span className="text-[11px] font-bold uppercase tracking-widest" data-id="element-615">
                Our Team
              </span>
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="text-4xl md:text-5xl font-bold text-[#225274] tracking-tight" data-id="element-616">
              Meet Your Clinical Specialists
            </motion.h1>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="text-lg text-slate-500 max-w-2xl mx-auto" data-id="element-617">
              Dedicated to providing you with the highest standard of dental
              care in a comfortable and welcoming environment.
            </motion.p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-618">
            {doctors.map((doctor, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: idx * 0.1 + 0.3
          }} className="bg-white rounded-[32px] overflow-hidden shadow-xl shadow-slate-200/50 border border-slate-50 group hover:-translate-y-2 transition-transform duration-300" data-id="element-619">
                <div className="aspect-[4/3] overflow-hidden relative" data-id="element-620">
                  <img src={doctor.image} alt={doctor.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-621" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#225274]/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-8" data-id="element-622">
                    <a href="/book" className="bg-white text-#[225274] px-6 py-2 rounded-full font-bold text-sm hover:bg-#[54c595] hover:text-white transition-colors" data-id="element-623">
                      Book with {doctor.name.split(' ')[1]}
                    </a>
                  </div>
                </div>
                <div className="p-8" data-id="element-624">
                  <h3 className="text-2xl font-bold text-[#225274] mb-2" data-id="element-625">
                    {doctor.name}
                  </h3>
                  <p className="text-[#54c595] font-bold uppercase tracking-widest text-xs mb-6" data-id="element-626">
                    {doctor.role}
                  </p>
                  <div className="h-px w-12 bg-slate-200 mb-6" data-id="element-627" />
                  <p className="text-slate-600 leading-relaxed" data-id="element-628">
                    <span className="font-bold text-slate-800" data-id="element-629">Specialty:</span>{' '}
                    {doctor.specialty}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </main>
      <Footer data-id="element-630" />
    </div>;
}